import { IDiagnosticImageReport } from '../../../types/diagnostic-image'
import { styles } from '../styles'
import CommentsBox from './CommentsBox'
import { Image, View } from '@react-pdf/renderer'

interface ImageZoneBoxProps {
  diagnosticImage: IDiagnosticImageReport
  imageSources: Record<string, string>
}

const ImageZoneBox = ({
  diagnosticImage,
  imageSources,
}: ImageZoneBoxProps) => {
  return (
    <View style={{ marginTop: 10 }}>
      {diagnosticImage.imageZones?.map((imageZone) => (
        <View
          wrap={false}
          style={{ ...styles.commentsContainer }}
          key={imageZone.id}
        >
          <View style={{ ...styles.smallWidthContainer, marginRight: 20 }}>
            <Image src={imageSources[imageZone.mediaUrl] ?? imageZone.mediaUrl} />
          </View>
          <View style={{ ...styles.largeWidthContainer }}>
            <CommentsBox imageZone={imageZone} />
          </View>
        </View>
      ))}
    </View>
  )
}

export default ImageZoneBox
